import type { LabelInValue } from 'models';
import { useTranslation } from 'react-i18next';
import { QrCodeModal } from 'ui';
import { getSafeFileName } from 'common/utils';
import { useGetInvitationToken } from '../../../queries/useGetInvitationToken';
import { useGenerateInvitationLink } from '../hooks';

type P = {
  community?: LabelInValue;
  isOpened: boolean;
  onCancel: () => void;
};

const ShareQrCodeModal = ({ community, isOpened, onCancel }: P) => {
  const { t } = useTranslation();

  const generateToken = useGenerateInvitationLink();

  const {
    data: invitationToken,
    error,
    isLoading,
  } = useGetInvitationToken({
    communityId: community?.value ?? '',
  });

  const fileName =
    typeof community?.label === 'string'
      ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
        `${getSafeFileName({ name: community?.label })} ${t('Invitation QR Code')}`
      : 'Community Invitation QR Code';

  return (
    <QrCodeModal
      alerts={[
        {
          description:
            'You can display the QR code for someone nearby, share it through messaging apps, or download it to your device for later use',
        },
        {
          description:
            'By scanning the QR code, the recipient can accept the invitation and join the platform seamlessly. The process is quick and straightforward.',
        },
      ]}
      error={error}
      fileName={fileName}
      isLoading={isLoading}
      isOpened={isOpened}
      onCancel={onCancel}
      qrCodeValue={generateToken({ communityId: community?.value ?? '', token: invitationToken ?? '' })}
      title="Invite via QR code"
    />
  );
};

export default ShareQrCodeModal;
